import './index.scss';
import Header from '../../../../../../../components/Header/Header';
import NoData from '../../../../../../../components/NoData/NoData';
import { useRef, useState } from 'react';
import { formatBracketText, formatToNaira, useOutsideClick } from '../../../../../../../helpers/utils';
import dayjs from 'dayjs';
import { LuMoreVertical } from 'react-icons/lu';

import updateMemo from '../../../../../../../assets/icons/updateMemo.svg';
import Info from '../../../../../../../assets/icons/Info.svg';
import trashIcon from '../../../../../../../assets/icons/trashr.svg';
import reverseIcon from '../../../../../../../assets/icons/reverseTransactions.svg';
import failureIcon from '../../../../../../../assets/icons/failureIcon.svg';
import successIcon from '../../../../../../../assets/icons/succesIcon.svg';
import Dropdown from '../../../../../../../components/Dropdown/Dropdown';
import TransactionDetailsAlt from '../../../../../../../components/NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import useFlexNaira from '../../../../../../../hooks/useFlexNaira';
import ModalDeleteTransaction from '../../../../../../../components/Modals/ModalDeleteTransaction';
import ModalUpdateTransactionMemo from '../../../../../../../components/Modals/ModalUpdateTransactionMemo';
import ModalTransactionSearch from '../../../../../../../components/Modals/ModalTransactionSearch';
import useTransaction from '../../../../../../../hooks/useTransaction';
import Pagination from '../../../../../../../components/Pagination/Pagination';
import { Loader } from '@piggytechng/component-library';

const index = () => {
  const {
    flexNairaTransactions,
    refetchFlexNairaTransactions,
    isLoadingFlexNairaTransactions,
    transactionsParams,
    setTransactionsParams,
    searchFlexNairaTransactions,
    clearFlexNairaSearch,
    searchedTransactions,
    isSearching,
  } = useFlexNaira();
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [appliedSearch, setAppliedSearch] = useState<{ filter: string; query: string } | null>(null);

  const transactionsToShow = searchedTransactions ?? flexNairaTransactions;

  const handleApplySearch = (filter: string, query: string) => {
    setAppliedSearch({ filter, query });
    searchFlexNairaTransactions(query, filter, 1, transactionsParams.limit);
    setShowSearchModal(false);
  };

  const handleResetSearch = () => {
    setAppliedSearch(null);
    clearFlexNairaSearch();
  };
  const { deleteTransaction, updateTransactionMemo, isLoading: isTransactionLoading } = useTransaction();
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedTransactionRef, setSelectedTransactionRef] = useState<string>('');
  const [showUpdateMemoModal, setShowUpdateMemoModal] = useState(false);
  const [selectedTransactionForMemo, setSelectedTransactionForMemo] = useState<{ reference: string; memo: string }>({
    reference: '',
    memo: '',
  });
  const [showDropdown, setShowDropdown] = useState({
    index: -1,
    show: false,
  });

  const dropdownRef = useRef(null);
  const actionRef = useRef(null);
  useOutsideClick(dropdownRef, setShowDropdown, actionRef);

  const handleShowTransactionsDetails = (data: any) => {
    setShow(true);
    setTrDetails(data);
  };

  const handleDeleteTransaction = (reference: string) => {
    setSelectedTransactionRef(reference);
    setShowDeleteModal(true);
  };

  const handleDeleteSuccess = () => {
    refetchFlexNairaTransactions();
  };

  const handleUpdateMemo = (reference: string, currentMemo: string) => {
    setSelectedTransactionForMemo({ reference, memo: currentMemo });
    setShowUpdateMemoModal(true);
  };

  const handleUpdateMemoSuccess = () => {
    refetchFlexNairaTransactions();
  };

  const handleShowDropdown = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, i: number) => {
    e.stopPropagation();
    if (i === showDropdown.index) {
      setShowDropdown({ ...showDropdown, show: false, index: -1 });
    } else {
      setShowDropdown({ ...showDropdown, show: true, index: i });
    }
  };

  const getDropdownArray = (reference: string, currentMemo: string) => [
    {
      icon: updateMemo,
      text: 'Update memo',
      fn: () => handleUpdateMemo(reference, currentMemo),
    },
    {
      icon: Info,
      text: 'See more info',
      fn: () => console.log('run'),
    },
    {
      icon: trashIcon,
      text: 'Delete transaction',
      fn: () => handleDeleteTransaction(reference),
    },
    {
      icon: reverseIcon,
      text: 'Reverse transaction',
      fn: () => console.log('run'),
    },
  ];

  return (
    <div className="view-all-flexnaira">
      <Header name={'Flex Naira Transactions'} backButton />

      <div className="content">
        <div className="customers-filter">
          <div className="input-field">
            <input
              type="text"
              readOnly
              placeholder="Search transactions"
              value={appliedSearch ? `${appliedSearch.filter}: ${appliedSearch.query}` : ''}
              onClick={() => setShowSearchModal(true)}
              style={{ cursor: 'pointer' }}
            />
          </div>
          <div className="query-filter" onClick={() => setShowSearchModal(true)}>
            <div>
              <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                  stroke="#1E293B"
                  strokeWidth="1.5"
                  strokeLinecap="square"
                />
              </svg>
            </div>
            <div>Search</div>
          </div>
          <div className="query-filter" onClick={handleResetSearch}>
            <div></div>
            <div>Reset</div>
          </div>
        </div>

        {isLoadingFlexNairaTransactions || isSearching ? (
          <div className="page-loader">
            <Loader color="#0F60D6" />
          </div>
        ) : (
          <>
            {transactionsToShow?.length ? (
              <div className="table-container flexnaira">
                <table className="table">
                  <thead className="table_head">
                    <tr>
                      <th className="icon">{''}</th>
                      <th className="title">Title</th>
                      <th className="date">Date</th>
                      <th className="amount">{`Amount (₦)`}</th>
                      <th className="balance">{`Balance (₦)`}</th>
                      <th className="memo">Memo</th>
                      <th className="reference">Reference</th>
                    </tr>
                  </thead>

                  <tbody className="table-body">
                    {transactionsToShow?.map((txn: any, i: number) => {
                      return (
                        <tr
                          key={txn.reference}
                          className="table-row"
                          onClick={() => handleShowTransactionsDetails(txn)}
                        >
                          <td className="icon">
                            <img
                              src={Number(txn.value) >= 0 ? successIcon : failureIcon}
                              alt={Number(txn.value) >= 0 ? 'credit' : 'debit'}
                            />
                          </td>
                          <td className="title">{formatBracketText(txn.title)}</td>
                          <td className="date">{dayjs(txn.date * 1000).format('D MMM YYYY | h:mm A')}</td>
                          <td className="amount">{formatToNaira(txn.value)}</td>
                          <td className="balance">{formatToNaira(txn.balance)}</td>
                          <td className="memo">{txn.memo}</td>
                          <td className="reference">{txn.reference ?? '-----'}</td>
                          <div className="dropdown-container" ref={actionRef}>
                            <button onClick={(e) => handleShowDropdown(e, i)} className="pointer">
                              <LuMoreVertical color="#CBD5E1" size={25} />
                            </button>

                            {showDropdown.index === i && showDropdown.show && (
                              <div className="table-dropdown" ref={dropdownRef}>
                                <Dropdown data={getDropdownArray(txn.reference, txn.memo || '')} index={i} />
                              </div>
                            )}
                          </div>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <NoData message={'No transaction at the moment.'} />
            )}

            {!searchedTransactions && (
              <Pagination
                currentPage={transactionsParams.page}
                hasNextPage={(flexNairaTransactions?.length ?? 0) >= transactionsParams.limit}
                hasPrevPage={transactionsParams.page > 1}
                onNextPage={() => setTransactionsParams((prev) => ({ ...prev, page: prev.page + 1 }))}
                onPrevPage={() => setTransactionsParams((prev) => ({ ...prev, page: Math.max(prev.page - 1, 1) }))}
                limit={transactionsParams.limit}
                onLimitChange={(newLimit) => setTransactionsParams({ page: 1, limit: newLimit })}
              />
            )}
          </>
        )}
      </div>

      <ModalTransactionSearch
        modalIsOpen={showSearchModal}
        setIsOpen={setShowSearchModal}
        onApply={handleApplySearch}
        onClear={handleResetSearch}
        isLoading={isSearching}
        initialFilter={appliedSearch?.filter}
        initialQuery={appliedSearch?.query}
      />

      <TransactionDetailsAlt
        show={show}
        which="flexnaira"
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
      {selectedTransactionRef && (
        <ModalDeleteTransaction
          modalIsOpen={showDeleteModal}
          setIsOpen={setShowDeleteModal}
          reference={selectedTransactionRef}
          wallet="flexnaira"
          onDelete={deleteTransaction}
          onSuccess={handleDeleteSuccess}
          isLoading={isTransactionLoading}
        />
      )}
      {selectedTransactionForMemo.reference && (
        <ModalUpdateTransactionMemo
          modalIsOpen={showUpdateMemoModal}
          setIsOpen={setShowUpdateMemoModal}
          reference={selectedTransactionForMemo.reference}
          wallet="flexnaira"
          currentMemo={selectedTransactionForMemo.memo}
          onUpdate={updateTransactionMemo}
          onSuccess={handleUpdateMemoSuccess}
          isLoading={isTransactionLoading}
        />
      )}
    </div>
  );
};

export default index;
